import Empty from "./Empty";

export default function TableEmpty({ title = "내역 없음", text = "해당되는 내역이 조회되지 않습니다" }) {
  return (
    <tr>
      <td colSpan="100">
        <Empty title={title} text={text} />
      </td>
    </tr>
  );
}
